import React from 'react';
import { FormRenderProps } from '@progress/kendo-react-form';
import { ContentTypeFieldResponse } from '@cs-cms/types';

interface FormFieldsSectionProps {
  ungroupedFields: ContentTypeFieldResponse[];
  groupedFields: Map<string, ContentTypeFieldResponse[]>;
  renderField: (ctField: ContentTypeFieldResponse, formRenderProps: FormRenderProps) => React.ReactNode;
  formRenderProps: FormRenderProps;
}

export const FormFieldsSection: React.FC<FormFieldsSectionProps> = ({
  ungroupedFields,
  groupedFields,
  renderField,
  formRenderProps
}) => {
  return (
    <div className="cpsForm">
      {ungroupedFields.map(ctField => renderField(ctField, formRenderProps))}

      {Array.from(groupedFields.entries()).map(([groupName, fields]) => (
        <div key={groupName} className="cpsFormGroup">
          <div className="cpsFormGroupHeader">
            <h3 className="cpsFormGroupTitle">{groupName}</h3>
          </div>
          <div className="cpsFormGroupFields">{fields.map(ctField => renderField(ctField, formRenderProps))}</div>
        </div>
      ))}
    </div>
  );
};
